import gameIds from 'a/hub/data/GameIds';

export const GAME_ID = gameIds.CURIOUS_CASES;

export const LEVEL_COUNT = 8;
export const ITEMS_PER_ROUND = 4;
export const CLUES_COUNT_FOR_SETTING_TRAP = 3;
export const MAX_WRONG_TRIES = 2;
export const MIN_ATTEMPTS_AT_ITEM_FOR_MASTERY = 2;
export const ITEMS_FAILED_COUNT_FOR_LEVEL_FAIL = 2;

export const TRAP_SELECTION_PANEL_WIDTH = 330;
export const SCROLLVIEW_HEIGHT = 450;

// increment this value if you need to change the shape of a user's save data
// in a way that will invalidate previous data.
// the saveDataReducer will automatically ignore any save data with a version lower than this value.
export const CURRENT_SAVE_DATA_VERSION = 3;

// Game screens
export const SCREENS = {
  PROGRESS: 'PROGRESS',
  STANDARD_VIEW: 'STANDARD_VIEW',
  ROOM_VIEW: 'ROOM_VIEW',
  CLUES_VIEW: 'CLUES_VIEW',
  PAYOFF_VIEW: 'PAYOFF_VIEW',
  LOADING: 'LOADING',
  ONBOARDING: 'ONBOARDING',
  TRY_AGAIN: 'TRY_AGAIN',
};

export const WRONG_FEEDBACK_DURATION = 2000;

export const REDUX_ACTIONS = {
  CHANGE_SCREEN: 'CHANGE_SCREEN',
  INITIALIZE_STANDARD_ITEM: 'INITIALIZE_STANDARD_ITEM',
  REPEAT_ONBOARDING: 'REPEAT_ONBOARDING',
  COMPLETE_INTRO: 'COMPLETE_INTRO',
  START_LEVEL: 'START_LEVEL',
  REGISTER_TAGGABLE_WORD_LAYOUT: 'REGISTER_TAGGABLE_WORD_LAYOUT',
  UPDATE_INFERENCE_STATE: 'UPDATE_INFERENCE_STATE',
  TOGGLE_EVIDENCE_SELECTION: 'TOGGLE_EVIDENCE_SELECTION',
  MARK_ITEM_AS_COMPLETE: 'MARK_ITEM_AS_COMPLETE',
  INCREMENT_WRONG_COUNT: 'INCREMENT_WRONG_COUNT',
  FAIL_STD_ITEM: 'FAIL_STD_ITEM',
  SET_IS_EVIDENCE_PANEL_SHAKING: 'SET_IS_EVIDENCE_PANEL_SHAKING',
  DISABLE_EVIDENCE: 'DISABLE_EVIDENCE',
  SET_TRAP: 'SET_TRAP',
  SET_IS_SELECTING_TRAP: 'SET_IS_SELECTING_TRAP',
  FAIL_TRAP: 'FAIL_TRAP',
  SELECT_CLUE: 'SELECT_CLUE',
  COMPLETE_LEVEL: 'COMPLETE_LEVEL',
  UPDATE_RECORDS: 'UPDATE_RECORDS',
  SET_VO_NAME: 'SET_VO_NAME',
  ON_VO_ENDS: 'ON_VO_ENDS',
  SET_INTRO_TEXT: 'SET_INTRO_TEXT',
  SET_ITEM_PART: 'SET_ITEM_PART',
  HIGHLIGHT_EVIDENCE: 'HIGHLIGHT_EVIDENCE',
  UPDATE_EVIDENCE_STATUS: 'UPDATE_EVIDENCE_STATUS',
};

export const BACKGROUNDS_MAP = {
  level1: 'Level1Background',
  level2: 'Levels2_7Background',
  level3: 'Levels3_6Background',
  level4: 'Levels4_8Background',
  level5: 'Level5Background',
  level6: 'Levels3_6Background',
  level7: 'Levels2_7Background',
  level8: 'Levels4_8Background',
};

export const INTRO_TEXT = {
  SUCCESS: 'Welcome back! Let\'s search for another clue. What catches your eye?',
  FAILED: 'Welcome back! That was tough. Let\'s search for another clue. What catches your eye?',
};

export const FALCON_FEEDBACK = {
  INFERENCE_CORRECT: (evidenceCount) =>
    (evidenceCount > 1
      ? `That's correct! Now highlight ${evidenceCount} sentences to support your claim.`
      : "That's correct! Now let's highlight our evidence."),
  EVIDENCE_CORRECT: "That's correct!",
  INFERENCE_INTRO: 'Read the passage carefully and answer the question.',
  EVIDENCE_INTRO: 'Click a sentence that supports your answer.',
  PRESS_NEXT: 'Press "Next" to continue.',
  PRESS_DONE: 'Press "Done" to submit.',
  QUESTION_FAILED: ['Hm not quite. Try Again!', 'Hm not quite. This is the correct answer.'],
  TAGS_LEFT: (tagsLeft) => `${tagsLeft} highlight${tagsLeft === 1 ? '' : 's'} left!`,
  NEXT_CLUE: "Nice work! Let's go search for more clues in the rooms.",
  CLUE_INTRO: (title) => `You've discovered one of many items in the room - ${title}`,
};

export const ITEM_PART = {
  INFERENCE: 'inference',
  EVIDENCE: 'evidence',
};

export const QUESTION_STATUS = {
  REVEALED: 'revealed',
  COMPLETED: 'completed',
  IN_PROGRESS: 'in-progress',
};

export const ACTION_BUTTON_TYPES = {
  NEXT: 'next',
  DONE: 'done',
};
